import { createAction } from 'app-components/flux/core/actionHelpers';

export const getAlerts = createAction('GET_ALERTS');
export const getAlertsSuccess = createAction('GET_ALERTS_SUCCESS');
export const getAlertsFailure = createAction('GET_ALERTS_FAILURE');

export const updateAlert = createAction(
  'UPDATE_ALERT',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updateAlertSuccess = createAction('UPDATE_ALERT_SUCCESS');
export const updateAlertFailure = createAction('UPDATE_ALERT_FAILURE');

export const deleteAlert = createAction('DELETE_ALERT');
export const deleteAlertSuccess = createAction('DELETE_ALERT_SUCCESS');
export const deleteAlertFailure = createAction('DELETE_ALERT_FAILURE');

export const batchAlerts = createAction(
  'BATCH_ALERTS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const batchAlertsSuccess = createAction(
  'BATCH_ALERTS_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const batchAlertsFailure = createAction('BATCH_ALERTS_FAILURE');
